import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { DescriptionColor } from '../../../enums/description-colors.enum';
import { Navigation } from '../../../models/navigation.model';
import * as fromDashboardActions from '../../../store/actions/dashboard/dashboard.actions';
import { Card } from './../../../models/card.model';
import * as fromAccountsActions from './../../../store/actions/accounts/accounts.actions';
import * as fromTemplatesActions from './../../../store/actions/templates/templates.actions';
import { AppState } from './../../../store/index';

@Component({
  selector: 'lns-page-link',
  templateUrl: './page-link.component.html',
  styleUrls: ['./page-link.component.scss']
})
export class PageLinkComponent {
  @Input() pageLink: Navigation | undefined;
  @Input() descriptionColor = DescriptionColor.TextGray;
  @Input() detailsLink = false;
  @Input() redDot = false;
  @Input() currency: string | undefined;
  @Input() bankCardData: Card | undefined;

  constructor(private store: Store<AppState>, private router: Router) {}

  refreshBalance(): void {
    this.store.dispatch(fromDashboardActions.refreshDashboardApi());
  }

  setSavingsRoute() {
    localStorage.setItem('prevRoute', 'savings');
  }

  setSavingsOrderRoute() {
    this.router.navigate([
      '/payments',
      { outlets: { details: ['new-payment', 'internal-payment'] } }
    ]);
  }

  additionalNavigationActions() {
    if (this.pageLink?.route) {
      if (this.pageLink?.name == `ic_option_menu_0`) {
        this.store.dispatch(fromAccountsActions.resetAccountTransactionDetails());
        this.store.dispatch(fromTemplatesActions.resetTemplateDetailsForm());
        this.store.dispatch(fromAccountsActions.resetUnsignedOrders());
        this.store.dispatch(
          fromAccountsActions.resetSelectedAccountUnsignedOrders()
        );
        this.router.navigate([this.pageLink.route]);
      }
    }
  }

  prepaidIban() {
    this.store.dispatch(
      fromAccountsActions.setPrepaidIban({
        prepaidIban: this.bankCardData?.maskCardNumber
      })
    );
  }
}
